import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { extractInsightsByKeysFromSetting } from '../../../useInsights/insights.formatters';

const useFormState = defaultValue => {
  const [formState, setFormState] = useState(defaultValue);

  const insightsKeys = useMemo(
    () => extractInsightsByKeysFromSetting(formState),
    [formState]
  );
  const hasFormChanged = useMemo(
    () => !_.isEqual(defaultValue, formState),
    [defaultValue, formState]
  );

  const updateInsight = (insightKey, payload) => {
    const updatedFormState = Object.keys(formState).reduce(
      (acc, categoryKey) => {
        const category = formState[categoryKey];
        const { insights } = category;
        const updatedCategory = {
          ...category,
          insights: Object.keys(insights).reduce((acc, currInsightKey) => {
            const insight = insights[currInsightKey];
            return {
              ...acc,
              [currInsightKey]:
                currInsightKey === insightKey
                  ? { ...insight, ...payload }
                  : insight
            };
          }, {})
        };
        return {
          ...acc,
          [categoryKey]: updatedCategory
        };
      },
      {}
    );
    setFormState(updatedFormState);
  };

  const getInsight = insightKey => insightsKeys[insightKey];

  const onToggleSwitch = e => {
    const { name: insightKey, checked } = e.target;
    updateInsight(insightKey, { active: checked });
  };

  useEffect(() => {
    setFormState(defaultValue);
  }, [defaultValue]);

  return {
    formState,
    hasFormChanged,
    onToggleSwitch,
    getInsight,
    updateInsight
  };
};

export default useFormState;
